import { Drawer as AntDrawer } from 'antd'
import type { ComponentProps } from 'react'

type AntDrawerProps = ComponentProps<typeof AntDrawer>

export interface AppDrawerProps extends Omit<AntDrawerProps, 'visible'> {
  open?: boolean
}

export const AppDrawer = ({ open, ...rest }: AppDrawerProps) => <AntDrawer open={open} {...rest} />
